import React, { Component } from "react";
import { Modal, Table, Icon } from "antd";
import moment from "moment";
import "../style.scss";
import { BusinessPartnerType } from "../../BusinessPartnerDetails/types";
import { changeLogLabelMap } from "../../../utils";
import { connect } from "react-redux";
import { fetchChangeLog, resetChangeLogData } from '../../ChangeLog/store/actions';
import { hot } from "react-hot-loader/root";
import { ChangeLogPayloadType, ChangeLogType } from "../../ChangeLog/types";
import { PaginationInfoType } from "../../BusinessPartnerLists/types";

interface ChangeLogProps {
  changeLog: ChangeLogType[];
  changeLogList: BusinessPartnerType;
  fetchChangeLog: (payload: ChangeLogPayloadType) => any;
  resetChangeLogData: () => any;
  close: (businessPartner: BusinessPartnerType | null) => void;
  paginationInfo: PaginationInfoType ;
}

interface ChangeLogState {
  columns: any[];
  isLoading: boolean;
  newDataSource: any[];
}
class changeLogModal extends Component<ChangeLogProps, ChangeLogState> {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      isLoading: false,
      newDataSource: [],
    };
  }

  componentDidMount() {
    const { changeLog } = this.props.changeLogList; // its a BP record.
    const newDataSource = changeLog.map((log) => {
      const {
        bpName,
        bpCityRefName,
        bpPostalcodeRefName,
      } = this.props.changeLogList;

      return {
        ...log,
        bpName,
        bpCityRefName,
        bpPostalcodeRefName,
      };
    });
    const {bpId} = this.props.changeLogList;
    this.props.resetChangeLogData();
    this.props.fetchChangeLog({ bpid: bpId});
    this.setState({ newDataSource });
  }

  getExpandableRowRenderer() {
    return (record) => {
      const expandableColumns = [
        {
          title: "",
          dataIndex: "fixedCol",
          key: "fixedCol",
          width: 7,
          fixed: true,
          render: (text) => (
            <span>
              <strong>{text}</strong>
            </span>
          ),
        },
      ];
      const beforeRow = { fixedCol: "Before" };
      const afterRow = { fixedCol: "After" };

      record.alChangedValues.forEach((change) => {
        let [label,width,fixed] = [change.alField, 100 , false];
        if(changeLogLabelMap[change.alField]) {
          [label,width,fixed] = [changeLogLabelMap[change.alField].title, changeLogLabelMap[change.alField].width, changeLogLabelMap[change.alField].fixed]
        }
        if(changeLogLabelMap[change.alField]) {
          const column = {
            title: label,
            dataIndex: change.alField,
            key: change.alField,
            width: width,
            fixed: fixed,
            render: (text) => text,
          };
          expandableColumns.push(column);
          beforeRow[change.alField] = change.alOldValue;
          afterRow[change.alField] = change.alNewValue;
        }
      })
      delete expandableColumns[expandableColumns.length - 1].width;

      const data = [beforeRow, afterRow];
      let tableWidth = expandableColumns.reduce(
        (a, c) => (c.width ? a + +c.width : a),
        50
      );
      return (
        <div style={{ width: 1080, overflow: "hidden" }}>
          <Table
            rowKey="fixedCol"
            columns={expandableColumns}
            dataSource={data}
            pagination={false}
            size="small"
            bordered
            scroll={{ x: tableWidth }}
            style={{ border: "1px solid #efefef" }}
          />
        </div>
      );
    };
  }

  getTableColumns(users) {
    return [
      {
        title: "Changed By",
        dataIndex: "alPerson",
        key: "alPerson",
        width: 200,
        sorter: (a: ChangeLogType, b: ChangeLogType) => {
          if (a.alPerson < b.alPerson) return -1;
          if (a.alPerson > b.alPerson) return 1;
          return 0;
        },
        filters: users && users.map((item) => ({ text: item, value: item })),
        onFilter: (value: string, record: ChangeLogType) =>
          record.alPerson.toLowerCase() === value.toLowerCase(),
      },

      {
        title: "Date",
        dataIndex: "alDateTime",
        key: "alDateTime",
        width: 100,
        sorter: (a: ChangeLogType, b: ChangeLogType) => {
          const aTime = new Date(a.alDateTime).getTime();
          const bTime = new Date(b.alDateTime).getTime();
          if (aTime < bTime) return -1;
          if (aTime > bTime) return 1;
          return 0;
        },
        render: (text: string) => moment(new Date(text)).format("MM-DD-YYYY h:mm:ss"),
      },
      {
        title: "Action",
        dataIndex: "alAction",
        key: "alAction",
        width: 100,
      }
    ];
  }

  closeModal() {
    this.props.resetChangeLogData();
    this.props.close(null);
  }

  handleTableChange = (pagination) => {
    const { paginationInfo } = this.props;
    const {bpId} = this.props.changeLogList;
    if (
      pagination.current !== paginationInfo.currentPage ||
      pagination.pageSize !== paginationInfo.pageSize
    ) {
      // pagination occured
      const payload = {
        sortBy: "",
        isSortAscending: true,
        page: pagination.current,
        pageSize: pagination.pageSize,
        bpid: bpId
      };
      this.props.fetchChangeLog(payload);
    }
  };

  render() {
    const { bpName } = this.props.changeLogList;
    const changeLog = this.props.changeLog || [];

    // Collect user list from change log
    const users = [];
    changeLog.forEach((item) => {
      if (item.alPerson && users.indexOf(item.alPerson) === -1) {
        users.push(item.alPerson);
      }
    });

    const columns = this.getTableColumns(users);
    const expandedRowRender = this.getExpandableRowRenderer();
    const { paginationInfo } = this.props;
    return (
      <Modal
        visible
        footer={null}
        onCancel={() => this.closeModal()}
        title={`Change log of ${bpName}`}
        width={1200}
        className="change-log-modal"
      >
        <Table
          dataSource={changeLog || []}
          rowKey="clId"
          scroll={{ y: 540 }}
          columns={columns}
          className="change-log-table"
          expandedRowRender={expandedRowRender}
          onChange={this.handleTableChange}
          pagination={{
            current: paginationInfo.currentPage,
            pageSize: paginationInfo.pageSize,
            total: paginationInfo.totalRecords,
            showSizeChanger: true,
            pageSizeOptions: ["15", "30", "50", "100"],
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} Business Partners`,
          }}
        />
      </Modal>
    );
  }
}


const mapStateToProps = ({ app, changeLog }) => ({
  userInfo: app.userInfo,
  users: changeLog.users,
  changeLog: changeLog.changeLog,
  paginationInfo: changeLog.paginationInfo
});

const mapDispatchToProps = {
  fetchChangeLog,
  resetChangeLogData
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hot(changeLogModal));
